import React from "react";
import { flexRender } from "@tanstack/react-table";
import ColumnHeader from "./ColumnHeader";

const TableHeader = ({
  table,
  activeColumns,
  isColumnPinned,
  getPinnedColumnStyle,
  isAnalyticsTable,
  hoverManager,
  handleDragStart,
  handleDragOver,
  handleDragEnd,
  handleDrop,
  initColumnResize,
  isResizingActive,
  activeResizingColumnId,
  hasActiveFiltersOrSorting,
  columnMenuManager,
  // Control panel props (function bar is now in BaseTable)
  hoveredColumn,
}) => {
  return (
    <thead>
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => {
            const columnId = header.column.id;
            const isDynamicColumn = columnId.startsWith("P") || columnId.startsWith("F");
            const isPinned = isColumnPinned(columnId);
            const isVertical = (header.getSize() || 250) < 100;
            const isActive = activeColumns[columnId] || false;

            return (
              <ColumnHeader
                key={header.id}
                header={header}
                colSpan={header.colSpan}
                isPinned={isPinned}
                getPinnedColumnStyle={getPinnedColumnStyle}
                columnId={columnId}
                hoveredColumn={hoveredColumn}
                isDynamicColumn={isDynamicColumn}
                isAnalyticsTable={isAnalyticsTable}
                isVertical={isVertical}
                onMouseEnter={(e) => hoverManager.handleHeaderMouseEnter(e, columnId)}
                onMouseLeave={(e) => hoverManager.handleHeaderMouseLeave(e, columnId)}
                onDragStart={(e) => handleDragStart(e, columnId)}
                onDragOver={handleDragOver}
                onDragEnd={handleDragEnd}
                onDrop={(e) => handleDrop(e, columnId)}
                onResizeStart={(e, columnId) => initColumnResize(e, columnId)}
                isResizing={isResizingActive}
                resizingColumnId={activeResizingColumnId}
                hasActiveFiltersOrSorting={hasActiveFiltersOrSorting(columnId)}
                onFilterButtonClick={(e, columnId) => {
                  columnMenuManager.handleToggleMenu(e, columnId);
                }}
                style={{
                  width: isActive ? "30px" : `${header.getSize()}px`,
                  minWidth: "50px",
                  height: isVertical ? "100px" : "30px",
                  position: isPinned ? "sticky" : "relative",
                  writingMode: isVertical ? "vertical-rl" : "horizontal-tb",
                  textOrientation: "mixed",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  padding: "0",
                  lineHeight: "30px",
                  ...(isPinned ? getPinnedColumnStyle(columnId) : {}),
                }}
              >
                <div
                  className={`flex w-full justify-center ${
                    isVertical
                      ? "h-full items-center justify-center"
                      : "items-start justify-center pt-1"
                  }`}
                  style={{
                    transform: isVertical ? "translateY(0)" : "none",
                    height: isVertical ? "100%" : "auto",
                  }}
                >
                  {header.isPlaceholder
                    ? null
                    : flexRender(header.column.columnDef.header, header.getContext())}
                </div>
              </ColumnHeader>
            );
          })}
        </tr>
      ))}
    </thead>
  );
};

export default TableHeader;